/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".place-category-selector hr{border-top:1px dashed #a9a9a9}.place-category-checkbox .mat-checkbox-checked .mat-checkbox-label{font-weight:700}"];
export { styles as styles };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/edit.place.category.modal/place.category.selector/place.category.selector.component.scss.ngstyle.js.pre-build-optimizer.js